import './main.scss'

import { attachDynamicEvent } from '~/common/helpers/dom'
import { getBaseCartPath } from '../../../site/pages/cart/common'
import { appendCsrfParams } from '~/common/helpers/csrf'
import { processResponse } from '../../../site/behaviors/remote/process_response'

function changeCurrency(event) {
  let currency = event.target.value
  toggleLoadingIndicator(true)

  let data = new URLSearchParams()
  data.append('currency', currency)
  appendCsrfParams(data)

  fetch(getBaseCartPath() + '/update_currency', {
    method: 'PATCH',
    body: data,
  })
    .then((response) => response.json())
    .then((json) => {
      processResponse(json)
      toggleLoadingIndicator(false)
    })
}

function toggleLoadingIndicator(loading) {
  let cart = document.querySelector('.cart')
  let cartItems = document.querySelectorAll('.cart__item')
  if (loading) {
    cart.classList.add('cart--loading')
    cartItems.forEach((el) => el.classList.add('cart__item--loading'))
  } else {
    cart.classList.remove('cart--loading')
    cartItems.forEach((el) => el.classList.remove('cart__item--loading'))
  }
}

window.addEventListener('DOMContentLoaded', () => {
  attachDynamicEvent('.cart #cart-change-currency', 'change', changeCurrency)
})
